import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const TodayIndicator = styled.div`
    font-family: AvenirNextWorld Demi;
    font-size: 13px;
    color: #140f4b;
    border: 1px solid #140f4b;
    border-radius: 14px;
    opacity: 0.98;
    width: 58px;
    height: 28px;
    display: flex;
    justify-content: center;
    background-color: #fcaa00;
    float: left;
    cursor: pointer;
    position: absolute;
    left: 0;
    margin-left: 0.9rem;
    align-self: center;
    align-items: center;

    ${media.mobileDevice`
    width: 47px;
    height: 18px;
    font-size: 10px;
    font-family: AvenirNextWorld Regular;
    /* border-radius: 9px; */
    margin-left: 1rem;
    `}
`;
